module.exports = __webpack_public_path__ + "img/collection.0555df14.svg";